import { RouteStaticConfig } from '@/core/types';

export const businessAccountJoinApplication: RouteStaticConfig = {
  guarded: false,
  path: '/public/join-application/:code',
  label: '',
  key: 'businessAccountApplication',
};
